import { config } from '../../main/config';
import {
  ITable,
  ITableColumn,
  ITableSort,
  TableAction,
  ITableSearchTag,
  prepareColumns,
} from '../../shared/ui/models/table';
import { ComponentType } from '../../shared/ui/models/component';
import { FilterType } from '../../shared/ui/models/tableSpecificFilters';

export class TradeReportingTable implements ITable {
  static index = 1;

  id: string;
  parentId: string;
  type: ComponentType = ComponentType.TradeReport;
  actions: TableAction[] = [
    TableAction.SEARCH,
    TableAction.DOWNLOAD_CSV,
    TableAction.HIDDING_ROWS,
    TableAction.PINNING_ROWS
  ];
  columns: ITableColumn[] = [];
  sorting: ITableSort[];
  hiddenColumnNames: string[];
  hiddenRows: any[] = [];
  tags: ITableSearchTag[] = [];
  showHeadlines: boolean = true;
  showingHidden: boolean = false;
  filters = {...{[FilterType.TRADES_OF_THE_DAY]: false}};
  pinnedRows = [];

  constructor(parentId: string, customId?: string) {
    this.id = customId
      ? customId
      : new Date().getUTCMilliseconds().toString() + TradeReportingTable.index++;
    this.parentId = parentId;
    this.columns = config.ui.tradeReportingTable.columns.map(c => { return {...c}; });

    if (customId) {
      this.hiddenColumnNames = prepareColumns(config.ui.tradeReportingTable, this.columns, true);
      this.sorting = config.ui.tradeReportingTable.recentDefaultSorting;
    } else {
      this.hiddenColumnNames = prepareColumns(config.ui.tradeReportingTable, this.columns, false);
      this.sorting = config.ui.tradeReportingTable.defaultSorting;
    }
  }
}
